/* P.Louise — Recommendations carousel
   Carousel scroll + arrow enable/disable, staggered entrance, AJAX add-to-cart
   with an "added to bag" toast. Each section instance is wired independently. */
(function () {
  function initSection(root) {
    if (!root || root.dataset.recInit === "1") return;
    root.dataset.recInit = "1";

    var track = root.querySelector("[data-rec-track]");
    var prevBtn = root.querySelector("[data-rec-prev]");
    var nextBtn = root.querySelector("[data-rec-next]");
    var toast = root.querySelector("[data-rec-toast]");
    var toastText = root.querySelector("[data-rec-toast-text]");
    if (!track) return;

    var toastTimer = null;

    /* ---- entrance stagger: add .animate after one frame ---- */
    requestAnimationFrame(function () { track.classList.add("animate"); });

    /* ---- arrow enable/disable ---- */
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    }

    function scrollByCard(dir) {
      var card = track.querySelector(".rec-card");
      var step = card ? card.offsetWidth + 12 : 240;
      track.scrollBy({ left: dir * step * 1.5, behavior: "smooth" });
    }

    if (prevBtn) prevBtn.addEventListener("click", function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { scrollByCard(1); });
    track.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();

    /* ---- toast ---- */
    function showToast(message) {
      if (!toast || !toastText) return;
      toastText.textContent = message;
      toast.classList.remove("show");
      void toast.offsetWidth; /* reflow so the animation restarts */
      toast.classList.add("show");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 2600);
    }

    function truncate(name) {
      return name.length > 32 ? name.slice(0, 30) + "…" : name;
    }

    /* ---- AJAX add-to-cart ---- */
    root.addEventListener("submit", function (e) {
      var form = e.target.closest("[data-rec-add]");
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector("button[type=submit]");
      var name = form.getAttribute("data-product-title") || "item";
      if (btn) btn.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || "Add to cart failed");
          showToast("Added to bag — " + truncate(name));
          document.dispatchEvent(new CustomEvent("rec:item-added", { detail: res.data, bubbles: true }));
        })
        .catch(function () {
          showToast("Couldn't add — " + truncate(name));
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-rec-root]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  /* Theme editor: re-init when a section is loaded/reordered */
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-rec-root]");
    if (root) initSection(root);
  });
})();